import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Edgar Allan Poe was 200 yesterday",
  "description": "",
  "published": "2009-01-20T00:00:00.000Z",
  "redirect_from": ["/blog/edgar-allan-poe-was-200-yesterday/swizec/15"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Most of you probably don't realise but Mr. Poe had his 200th birthday yesterday, which is a once in a lifetime event ... or for him a once in a post mortem event ... so I decided to at least raise a glass of cognac to his genius, if I can't afford a trip to Boston. Air travel ticket prices bloody suck if you ask me, a three day trip to my favourite poet's birthday party would cost upwards of a thousand euro just to get there and back. Let alone staying there for three days.`}</p>
    <p>{`The most surprising thing about cognac was that it's extremely expensive. I mean, 18 euro for a glass? What the fuck!? But I was assured it was a really good cognac with a bottle costing several hundred euro and since it was Poe's birthday I decided to have the glass anyhow. Poor student and all.`}</p>
    <p>{`Cognac, some Remy Martin thing, was absolutely divine! I loved it. The taste was lovably soft and gentle, the smell was magnificent and I loved the whole experience. However I wish I could have the cognac over Poe's grave and "talk" to him about how much of an inspiration he's been to me over the years and how I've read most of his works at least twice.`}</p>
    <p>{`As a bit of trivia, did you know that every year on Poe's birthday a misterious man nobody knows leaves a bottle of cognac and a glass on Poe's grave? I've always found that very intriguing.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      